export enum PasswordResetStep {
  WAITING = "waiting",
  PASSWORD = "password",
  SUCCESS = "success",
}
